import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";
import { getUserDetails } from "../Slice/UserSlice";

export const getUserDetailsAPI = (params, callBack) => {
  console.log("params")
  console.log(params)
  return async () => {
    try {
      let url = ApiConstants.userUrl;
      const queryParams = [];

      if (params?.searchQuery)
        queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
      if (params.page)
        queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit)
        queryParams.push(`limit=${encodeURIComponent(params.limit)}`);
      if (params.userId)
        queryParams.push(`user_id=${encodeURIComponent(params.userId)}`);
      if (params.userRoleId)
        queryParams.push(`user_role_id=${encodeURIComponent(params.userRoleId)}`);
      if (params.userStatusId)
        queryParams.push(`user_status_id=${encodeURIComponent(params.userStatusId)}`);
      if (params.companyId)
        queryParams.push(`company_id=${encodeURIComponent(params.companyId)}`);

      // Append query parameters to URL if they exist
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      await apiGet(url)
        .then((response) => {
          callBack && callBack(response);
        })
        .catch((err) => {
          console.log("get user api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get user api err:", err);
      throw err;
    }
  };
};

export const getUserByRoleIdAPI = (userRoleId, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.getUserByRoleIdUrl}?user_role_id=${userRoleId}`
      )
        .then((response) => {
          callBack && callBack(response);
        })
        .catch((err) => {
          console.log("get user api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get user api err:", err);
      throw err;
    }
  };
};

export const getLoggedInUserDetailsAPI = (data, callBack) => {
  return async (dispatch) => {
    try {
      await apiGet(ApiConstants.getLoggedInUserDetailsUrl, data)
        .then((response) => {
          callBack && callBack(response, Response);
          response?.status === true && dispatch(getUserDetails(response));
        })
        .catch((err) => {
          console.log("get dashboard details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get dashboard details api err:", err);
      throw err;
    }
  };
};

export const getUserAdditionalInfoQuestionIdAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.getUserAdditionalInfoQuestionUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get dashboard details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get dashboard details api err:", err);
      throw err;
    }
  };
};

export const addUserAdditionalInfoAnswerValueAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.addUserAdditionalInfoAnswerValueUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get dashboard details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get dashboard details api err:", err);
      throw err;
    }
  };
};

export const addToUserAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createUserUrl, data)
        .then((response) => {
          callBack && callBack(response?.data);
        })
        .catch((err) => {
          console.log("add user api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add user api err:", err);
      throw err;
    }
  };
};

export const updateUserAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.updateUserUrl, data)
        .then((response) => {
          callBack && callBack(response?.data);
        })
        .catch((err) => {
          console.log("update user api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update user api err:", err);
      throw err;
    }
  };
};

export const deleteUserAPI = (userId, callBack) => {
  return async () => {
    try {
      await apiDelete(`${ApiConstants.deleteUserUrl}?user_id=${userId}`)
        .then((response) => {
          callBack && callBack(response?.data);
        })
        .catch((err) => {
          console.log("delete user api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("delete user api err:", err);
      throw err;
    }
  };
};

// export const logOutUserAPI = (data, callBack) => {
//   return async () => {
//     try {
//       await apiPost(ApiConstants.logoutUserUrl, data)
//         .then((response) => {
//           callBack && callBack(response, response);
//         })
//         .catch((err) => {
//           console.log("delete user role permission api err===-=>>>:", err);
//           throw err;
//         });
//     } catch (err) {
//       console.log("delete user role permission api err:", err);
//       throw err;
//     }
//   };
// };

export const logOutUserAPI = (params, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.logoutUserUrl, params)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("logout user api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("logout user api err:", err);
      throw err;
    }
  };
};

export const getAllBrands = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getAllBrandsUrl}?${data}=true`)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get all brands api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get all brands api err:", err);
      throw err;
    }
  };
};

export const getCategoriesByBrand = (data, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.getCategoriesByBrandUrl}?manufacturer_id=${data}`
      )
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get categories by brand api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get categories by brand api err:", err);
      throw err;
    }
  };
};

export const getUserStatusAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getUserStatusUrl}`)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get user status api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get user status api err:", err);
      throw err;
    }
  };
};
export const getUserRoleAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getUserRolesUrl}`)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get user status api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get user status api err:", err);
      throw err;
    }
  };
};